import { isTag } from 'anodum';
import instance from '../../instance';

const pickUpPhoneLink = (element) => {
  const { children } = element;
  for (let i = 0, l = children.length; i < l; i += 1) {
    const node = children[i];
    if (isTag(node, 'a') && instance.driver.referenceMap.hasReference(node)) {
      const linkHref = node.getAttribute('href');

      if (linkHref && linkHref.startsWith('tel:')) {
        return node;
      }

      return null;
    }
  }
  return null;
};

export default pickUpPhoneLink;
